import React from 'react'

import SvgIcon from './svgIcon'

const data = {
  id: 'linkedin',
  viewBox: '0 0 24 24',
  children: [
    {
      name: 'path',
      d: 'M19,0H5A5,5,0,0,0,0,5V19a5,5,0,0,0,5,5H19a5,5,0,0,0,5-5V5A5,5,0,0,0,19,0ZM8,19H5V8H8ZM6.5,6.732A1.764,1.764,0,1,1,8.25,4.968,1.758,1.758,0,0,1,6.5,6.732ZM20,19H17V13.4c0-3.368-4-3.113-4,0V19H10V8h3V9.765c1.4-2.586,7-2.777,7,2.476Z',
    },
  ],
}

const Icon = (props) => {
  return (
    <SvgIcon
      {...props}
      data={data}
    />
  )
}

export default Icon
